import {getConfigFields} from '../fields.js'
import {defaultInitFieldValue, formFieldIds} from '../values.js'

const {kilometersId, notification, plate} = formFieldIds

const formSellerPlateInitFields = {
  [kilometersId]: defaultInitFieldValue,
  [plate]: defaultInitFieldValue
}

const formSellerPlateFieldsConfig = [
  getConfigFields[plate]({
    customProps: {
      help: 'FORM.PLATE.FORMAT_EXAMPLE_HELP_TEXT',
      hint: null
    }
  }),
  getConfigFields[notification](),
  getConfigFields[kilometersId]({
    customProps: {
      help: 'PUBLISH_AD.WITH_PLATE.KMS_TO_RECOMMEND_PRICE',
      label: 'COMMON.KMS'
    }
  })
]

export const formSellerPlateConfig = {
  fields: formSellerPlateFieldsConfig,
  initFields: formSellerPlateInitFields
}
